import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { EqmInspectResultDetailDto, EqmInspectResultHeaderDto } from "src/dtos/eqmInspectResult/eqmInspectResultDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { EQM2080_R01InspectMasterDto } from "./Dto_EQM2080_R01";
import { EQM2080_R01Filter } from "./Store_EQM2080_R01";

const baseUrl = `${config.apiUrl}/EQM2080_R01`;

const getParams = (filter: Partial<EQM2080_R01Filter>, listLength?: number) => ({
	compCd: filter.compCd || "",
	inspectDt: filter.inspectDt || "",
	equipmentCd: filter.equipmentCd || "",
	listLength: listLength || 0,
});

export const getEQM2080_R01List = async (
	option: string,
	params: Partial<EQM2080_R01Filter>,
	listLength: number = 0,
) => {
	const url = `${baseUrl}/${option}`;
	return await getData<ResponseDto<EqmInspectResultHeaderDto[]>>(url, {
		params: getParams(params, listLength),
	});
};

export const getEQM2080_R01AllCount = async (params: Partial<EQM2080_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, {
		params: getParams(params, 0),
	});
};

export const getEQM2080_R01DetailList = async (inspectNo: string) => {
	const url = `${baseUrl}/detail/${inspectNo}`;
	return await getData<ResponseDto<EqmInspectResultDetailDto[]>>(url);
};

export const getEQM2080_R01InspectList = async (params: Partial<EQM2080_R01Filter>) => {
	const url = `${baseUrl}/inspect`;
	return await getData<ResponseDto<EQM2080_R01InspectMasterDto[]>>(url, {
		params: getParams(params, 0),
	});
};

export const postEQM2080_R01 = async (data: EqmInspectResultDetailDto[]) => {
	const url = `${baseUrl}`;
	return await postData<EqmInspectResultDetailDto[], ResponseDto<EqmInspectResultDetailDto[]>>(url, data);
};

export const patchEQM2080_R01 = async (data: EqmInspectResultDetailDto[]) => {
	const url = `${baseUrl}`;
	return await patchData<EqmInspectResultDetailDto[], ResponseDto<EqmInspectResultDetailDto[]>>(url, data);
};

export const deleteEQM2080_R01 = async (inspectNo: string, itemNo?: string) => {
	const url = `${baseUrl}`;
	return await deleteData<ResponseDto<any>>(url, {
		params: {
			inspectNo,
			itemNo,
		},
	});
};

export const downloadExcel_EQM2080_R01 = async (
	option: string,
	inspectNo: string,
	listLength: number = 0,
) => {
	const url = `${baseUrl}/excel/${option}`;
	return await getData<ResponseDto<string>>(url, {
		params: {
			inspectNo,
			listLength,
		},
	});
};

export const getPdfBlob_EQM2080_R01 = async (
	filter: Partial<EQM2080_R01Filter>,
): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: {
			compCd: filter.compCd || "",
			equipmentCd: filter.equipmentCd || "",
			inspectDt: filter.inspectDt || "",
			printDt: filter.printDt || "",
		},
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};
